'use strict';

var randomByte = require('./random/random-byte');

function encode(lookup, number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = encode;



//////////////////
// WEBPACK FOOTER
// ./~/shortid/lib/encode.js
// module id = 375
// module chunks = 5 7 8 9 10 11 13 22 23 24 25 29 57 58